document.addEventListener('DOMContentLoaded', () => {
  function parseBadges(raw) {
    if (!raw) return [];

    return raw.split('\n').map(line => {
      const [label, color] = line.split('|').map(s => s.trim());
      if (!label) return null;

      return {
        label,
        color: (color || 'black').toLowerCase()
      };
    }).filter(Boolean);
  }

  function render(wrapper, badges) {
    wrapper.innerHTML = '';

    badges.forEach(badge => {
      const el = document.createElement('span');
      el.className = `badge ${badge.color}`;
      el.textContent = badge.label;
      wrapper.appendChild(el);
    });
  }

  function initBadges(container) {
    const wrapper = container.querySelector('.badges.n2');

    const productRaw = container.dataset.productBadges || '';
    const variantsMap = JSON.parse(container.dataset.variantsBadges || '{}');

    // « BEST SELLER » et « BEST-SELLER » désignent le même statut : sans normalisation, une
    // pastille de variante qui répète celle du produit s'affiche deux fois sur la carte.
    // Ces libellés se saisissent à la main dans l'admin, l'écart de frappe est à prévoir.
    const cle = badge => badge.label.toUpperCase().replace(/[\s-]+/g, ' ').trim();

    function update(variantId) {
      const productBadges = parseBadges(productRaw);
      const variantsBadges = parseBadges(variantsMap[variantId]);

      const merged = [];
      [...productBadges, ...variantsBadges].forEach(badge => {
        if (!merged.some(garde => cle(garde) === cle(badge))) merged.push(badge);
      });
      render(wrapper, merged);
    }

    const card = container.closest('.variable-products');

    if (card) update(card.dataset.variantId);
    else render(wrapper, parseBadges(productRaw));
  }

  document.querySelectorAll('.product-card--badges').forEach(initBadges);
});